import { render, staticRenderFns } from "./DomainProfile.vue?vue&type=template&id=1d3f49cb&"
import script from "./DomainProfile.vue?vue&type=script&lang=js&"
export * from "./DomainProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports